import React from 'react';
import Logo from './Logo';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <div className="site-logo">
          <Logo size={24} idPrefix="footer" />
          <span className="site-logo-text">Sunsoft<span className="site-logo-accent">Gaming</span></span>
        </div>
        <p className="footer-tagline">Play smart. Cash out smarter.</p>
        <p className="footer-copy">© {new Date().getFullYear()} SunSoftGaming. All rights reserved. Play responsibly.</p>
      </div>
    </footer>
  );
}
